/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Servicebusqueuename3Inputs */

const en_entity_servicebusqueuename3 = /** @type {(inputs: Entity_Servicebusqueuename3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service Bus Queue Name`)
};

const de_entity_servicebusqueuename3 = /** @type {(inputs: Entity_Servicebusqueuename3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service Bus Queue Name`)
};

/**
* | output |
* | --- |
* | "Service Bus Queue Name" |
*
* @param {Entity_Servicebusqueuename3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_servicebusqueuename3 = /** @type {((inputs?: Entity_Servicebusqueuename3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Servicebusqueuename3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_servicebusqueuename3(inputs)
	return de_entity_servicebusqueuename3(inputs)
});
export { entity_servicebusqueuename3 as "entity_serviceBusQueueName" }